import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { EVENT_ACTION } from '../../../constants/PiezometryEventConstants'
import { getTitleCard } from '../EventFormUtils'
import EventCentralCard from './EventCentralCard'
import EventSensorCard from './EventSensorCard'
import EventTelecomCard from './EventTelecomCard'
import { EQUIPMENT } from 'materiel/constants/MaterielConstants'
import { Card, CardContent, Stack } from '@mui/material'


const EventEquipmentCard = ({
    materiels = {},
    testSignal = [],
    disabled = {},
    formActions = [],
    getLastReplacementDate = () => {},
    setFormAction = () => {},
    onChangeTestSignal = () => {},
    getBooleanChoiceWithAction = () => {},
}) => {
    const {
        equipmentTypes,
    } = useSelector(store => ({
        equipmentTypes: store.EquipmentReducer.equipmentTypes,
    }), shallowEqual)
    const {
        equipment = {},
        central = [],
        sensor = [],
        telecom = [],
        powerSupply = [],
    } = materiels
    return (
        <Card>
            {getTitleCard(i18n.equipment, EQUIPMENT, equipment, equipmentTypes)}
            <CardContent>
                <Stack spacing={1} padding={0.5}>
                    {
                        telecom.map((t, i) => (
                            <EventTelecomCard
                                key={i}
                                telecom={t}
                                hasSignalTestAction={testSignal.includes(t.id)}
                                disabled={disabled}
                                formActions={formActions}
                                lastReplacementDate={getLastReplacementDate(EVENT_ACTION.REMPLACEMENT_PILES_TELETRANSMISSION, t.id)}
                                setFormAction={setFormAction}
                                onChangeTestSignal={v => onChangeTestSignal(v, t.id)}
                                getBooleanChoiceWithAction={getBooleanChoiceWithAction}
                                displaySupply={!central.length}
                                hasPowerSupply={!!powerSupply.length}
                            />

                        ))
                    }
                </Stack>
                <Stack spacing={1} padding={0.5}>
                    {
                        sensor.map((s, i) => (
                            <EventSensorCard
                                key={i}
                                sensor={s}
                                formActions={formActions}
                                disabled={disabled}
                                lastReplacementDate={getLastReplacementDate(EVENT_ACTION.REMPLACEMENT_PILES_CAPTEUR, s.id)}
                                setFormAction={setFormAction}
                                getBooleanChoiceWithAction={getBooleanChoiceWithAction}
                                displaySupply={!central.length}
                                hasPowerSupply={!!powerSupply.length}
                            />
                        ))
                    }
                </Stack>
                <Stack spacing={1} padding={0.5}>
                    {
                        central.map((c, i) => (
                            <EventCentralCard
                                key={i}
                                central={c}
                                formActions={formActions}
                                disabled={disabled}
                                lastReplacementDate={getLastReplacementDate(EVENT_ACTION.REMPLACEMENT_PILES_CENTRALE, c.id)}
                                setFormAction={setFormAction}
                                getBooleanChoiceWithAction={getBooleanChoiceWithAction}
                                hasPowerSupply={!!powerSupply.length}
                            />
                        ))
                    }
                </Stack>
            </CardContent>
        </Card>
    )
}

EventEquipmentCard.propTypes = {
    materiels: PropTypes.object,
    testSignal: PropTypes.arrayOf(PropTypes.number),
    disabled: PropTypes.object,
    formActions: PropTypes.arrayOf(PropTypes.object),
    getLastReplacementDate: PropTypes.func,
    setFormAction: PropTypes.func,
    onChangeTestSignal: PropTypes.func,
    getBooleanChoiceWithAction: PropTypes.func,
}

export default EventEquipmentCard